// Mock MSQ Accreditation data for testing purposes
export const mockMsqAccreditations = [
  {
    id: 1,
    title: '<h2><strong>ISO 9001:2015</strong> Quality Management</h2>',
    status: 'active',
    description: '<p><strong>Quality management system certification</strong> for manufacturing processes.</p><ul><li>Process improvement</li><li>Customer satisfaction</li><li>Continuous improvement</li></ul>',
    certificate_number: 'ISO9001-2024-001-ABC',
    video_url: '<p><strong>Training Video:</strong> <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ" target="_blank">ISO 9001:2015 Quality Management Overview</a></p>',
    created_at: '2024-01-15T10:30:00Z',
    updated_at: '2024-03-20T14:45:00Z'
  },
  {
    id: 2,
    title: '<h3><em>ISO 14001:2015</em> Environmental Management</h3>',
    status: 'active',
    description: '<p><em>Environmental management system certification</em> focusing on:</p><ol><li><strong>Sustainability</strong> practices</li><li>Environmental impact reduction</li><li>Compliance with regulations</li></ol>',
    certificate_number: 'ISO14001-2024-002-DEF',
    video_url: '<h4>Environmental Management Training</h4><p><em>Video Series:</em> <a href="https://www.youtube.com/watch?v=9bZkp7q19f0" target="_blank">ISO 14001:2015 Implementation Guide</a></p>',
    created_at: '2024-02-01T09:15:00Z',
    updated_at: '2024-03-18T16:20:00Z'
  },
  {
    id: 3,
    title: '<h4><u>OHSAS 18001:2007</u> Occupational Health and Safety</h4>',
    status: 'active',
    description: '<h3>Occupational Health and Safety Management System</h3><p>Comprehensive safety protocols including:</p><ul><li>Risk assessment procedures</li><li>Employee training programs</li><li>Incident reporting systems</li><li>Emergency response plans</li></ul>',
    certificate_number: 'OHSAS18001-2024-003-GHI',
    video_url: '<div><h4><u>Safety Training Videos</u></h4><ul><li><a href="https://vimeo.com/123456789" target="_blank">OHSAS 18001:2007 Safety Protocols</a></li><li><strong>Duration:</strong> 45 minutes</li><li><em>Language:</em> English</li></ul></div>',
    created_at: '2024-01-20T11:00:00Z',
    updated_at: '2024-03-15T13:30:00Z'
  },
  {
    id: 4,
    title: 'ISO 27001:2013 Information Security Management',
    status: 'pending_renewal',
    description: 'Information security management system certification',
    certificate_number: 'ISO27001-2024-004-JKL',
    video_url: '<p><strong>Information Security Training:</strong></p><ol><li><a href="https://www.youtube.com/watch?v=oHg5SJYRHA0" target="_blank">ISO 27001:2013 Fundamentals</a></li><li><em>Advanced Topics:</em> <a href="https://www.youtube.com/watch?v=example2" target="_blank">Risk Assessment</a></li></ol>',
    created_at: '2024-02-10T08:45:00Z',
    updated_at: '2024-03-19T10:15:00Z'
  },
  {
    id: 5,
    title: 'FDA 21 CFR Part 11 Electronic Records',
    status: 'expired',
    description: 'Electronic records and electronic signatures compliance',
    certificate_number: 'FDA21CFR11-2024-005-MNO',
    video_url: '<h3>FDA Compliance Training</h3><p><strong>Electronic Records:</strong> <a href="https://www.youtube.com/watch?v=3JZ_D3ELwOQ" target="_blank">21 CFR Part 11 Compliance Guide</a></p><p><em>Includes:</em> Digital signatures, audit trails, and validation requirements</p>',
    created_at: '2024-02-15T14:20:00Z',
    updated_at: '2024-03-21T09:45:00Z'
  },
  {
    id: 6,
    title: 'SOC 2 Type II Security and Availability',
    status: 'active',
    description: 'Service Organization Control 2 Type II certification',
    certificate_number: 'SOC2-2024-006-PQR',
    video_url: 'https://www.youtube.com/watch?v=QH2-TGUlwu4',
    created_at: '2024-01-25T15:30:00Z',
    updated_at: '2024-03-17T11:20:00Z'
  },
  {
    id: 7,
    title: 'PCI DSS Payment Card Industry Data Security',
    status: 'active',
    description: 'Payment card industry data security standard compliance',
    certificate_number: 'PCIDSS-2024-007-STU',
    video_url: 'https://www.youtube.com/watch?v=YQHsXMglC9A',
    created_at: '2024-02-05T12:00:00Z',
    updated_at: '2024-03-10T14:00:00Z'
  },
  {
    id: 8,
    title: 'GDPR Data Protection Compliance',
    status: 'active',
    description: 'General Data Protection Regulation compliance certification',
    certificate_number: 'GDPR-2024-008-VWX',
    video_url: 'https://www.youtube.com/watch?v=YQHsXMglC9A',
    created_at: '2024-01-30T16:45:00Z',
    updated_at: '2024-03-22T08:30:00Z'
  }
];

// MSQ Accreditation statuses for filtering
export const msqAccreditationStatuses = [
  { value: 'active', label: 'Active', color: 'bg-green-100 text-green-800' },
  { value: 'expired', label: 'Expired', color: 'bg-red-100 text-red-800' },
  { value: 'pending_renewal', label: 'Pending Renewal', color: 'bg-yellow-100 text-yellow-800' },
  { value: 'suspended', label: 'Suspended', color: 'bg-orange-100 text-orange-800' },
  { value: 'revoked', label: 'Revoked', color: 'bg-gray-100 text-gray-800' }
];

// Issuing bodies for reference
export const issuingBodies = [
  'International Organization for Standardization',
  'British Standards Institution',
  'Food and Drug Administration',
  'American Institute of CPAs',
  'PCI Security Standards Council',
  'European Data Protection Board',
  'National Institute of Standards and Technology',
  'International Electrotechnical Commission'
];

// Accreditation types for reference
export const accreditationTypes = [
  'Quality Management',
  'Environmental Management',
  'Health and Safety',
  'Information Security',
  'Data Protection',
  'Financial Services',
  'Manufacturing',
  'Healthcare',
  'Education',
  'Government'
];
